import CityAnalytics from "./CityAnalytics";
import React, { useState } from "react";

export const ReportsHome = () => {
  const [activeTab, setActiveTab] = useState("cities");

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-white">Analytics Dashboard</h1>
        
        {/* Tab Navigation */}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setActiveTab("cities")}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              activeTab === "cities"
                ? "bg-indigo-600 text-white"
                : "bg-gray-800 text-gray-300 hover:bg-gray-700"
            }`}
          >
            City Analytics
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === "cities" && <CityAnalytics />}
    </div>
  );
};

export default ReportsHome;
